// extracted by mini-css-extract-plugin
module.exports = {"page":"canvas_page__3xrlG"};